var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var Download = function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "22" }, props),
        React.createElement("path", { fill: color, d: "M23 15a1 1 0 0 1 1 1v5a1 1 0 0 1-.883.993L23 22H1a1 1 0 0 1-1-1v-5a1 1 0 0 1 2 0v4h20v-4a1 1 0 0 1 1-1zM12.015.787a.891.891 0 0 1 .69.261.91.91 0 0 1 .294.68v12.013l4.353-4.52A.856.856 0 0 1 18 8.926a.94.94 0 0 1 .66.262.835.835 0 0 1 .282.638 1 1 0 0 1-.25.67l-5.944 6.152a.866.866 0 0 1-.659.293.865.865 0 0 1-.659-.293l-5.965-6.194a.9.9 0 0 1-.25-.628c0-.265.097-.488.292-.67a.85.85 0 0 1 .649-.26.923.923 0 0 1 .648.281l4.353 4.52V1.709c0-.237.084-.447.251-.628a.871.871 0 0 1 .607-.293z" })));
};
Download.defaultProps = {
    color: '#333',
};
export default Download;
//# sourceMappingURL=Download.js.map